import {TFormSchema, TGridSchema} from "@/comn/hooks";
import {ptlEnvs} from "@/tra/tancis/ptli/comn";
import {api} from "@/comn";
import {comnUtils} from "@/comn/utils";


/*
 * Role Management Service
 * !== 역할 관리 Service ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/ptl/role-auth`,
    api : `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/ptl/role-auth/role-auth`
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli1016001q: `${BASE.path}/ptli1016001q`,
    ptli1016002s: `${BASE.path}/ptli1016002s`,
    ptli1016003q: `${BASE.path}/ptli1016003q`,
    ptli1016004q: `${BASE.path}/ptli1016004q`,
}

export const PGEUIDS = {
    ptli1016001q: "ptli1016001q",
    ptli1016002s: "ptli1016002s",
    ptli1016003q: "ptli1016003q",
    ptli1016004q: "ptli1016004q",
}

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {

    // Select Role and Auth List !== 역할 및 권한 목록 조회 ==!
    getRoleAuthList: (data: any, page: number, size: number) => api.get(`${BASE.api}?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) }),

    // Select Menu List !== 메뉴 목록 조회 ==!
    getMenuList: (data: any) => api.get(`${BASE.api}/menu`, { params: comnUtils.toGetParams({ptlTpCd: data.ptlTpCd, authId: data.authId } ) }),

    // Select Role List !== 권한 목록 조회 ==!
    getAuthList: (data: any, page: number, size: number) => api.get(`${BASE.api}/auth?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) }),

    // Select Role and Auth Link Detail !== 역할 및 권한 상세 조회 ==!
    getRoleAuthDtl: (data: any) => api.get(`${BASE.api}/${data.roleId}`, { params: comnUtils.toGetParams({bsopClsfCd: data.bsopClsfCd, ptlTpCd: data.ptlTpCd})}),

    // Save Role and Auth Link Detail !== 역할 및 권한 연결 상세 저장 ==!
    saveRoleAuthDtl: (data: any) => api.post(`${BASE.api}/${data.roleId}`, {...data}),
}

export const SF_ROLE_DTL: TFormSchema = {
    id: "form_roleDtl",
    schema: {
        ptlTpCd    : { type: "select", label : "L_PTL_TP_CD",  edit: false, area  : "comnCd", comnCd: "COM0052", excludes: ["B"] },
        roleId     : { type: "text", label: "L_ROLE_ID", edit: false },
        roleNm     : { type: "text", label: "L_ROLE_NM", edit: false },
        roleDesc   : { type: "text", label: "L_DESC"   , edit: false }
    }
}

export const SF_ROLE_SRCH: TFormSchema = {
    id: "form_roleSrch",
    schema: {
        ptlTpCd    : { required: true, type: "select", label : "L_PTL_TP_CD", area  : "comnCd", comnCd: "COM0052", excludes: ["B", "E", "O"] },
        roleId     : { type: "text", label: "L_ROLE_ID" },
        roleNm     : { type: "text", label: "L_ROLE_NM" },
    }
}

export const SF_AUTH_SRCH: TFormSchema = {
    id: "form_authSrch",
    schema: {
        ptlTpCd    : { required: true, type: "select", label : "L_PTL_TP_CD", area  : "comnCd", comnCd: "COM0052", excludes: ["B"] },
        authId     : { type: "text", label: "L_AUTH_ID" },
        authNm     : { type: "text", label: "L_AUTH_NM" },
    }
}

export const SG_ROLE_AUTH_LIST:TGridSchema = {
    id: "grid_roleAuthList",
    options: { checkbox: true },
    head: [
        { cells: [{ header: "L_PTL_TP_CD"         , binding: "ptlTpCd"        , width: "*" }], show: false },
        { cells: [{ header: "L_ROLE_ID"           , binding: "roleId"         , width: "*" }]},
        { cells: [{ header: "L_ROLE_NM"           , binding: "roleNm"         , width: "*" }]},
        { cells: [{ header: "L_ROLE_DESC"         , binding: "roleDesc"       , width: "*" }]},
        { cells: [{ header: "L_AUTH_ID"           , binding: "authId"         , width: "*" }], show: false},
        { cells: [{ header: "L_AUTH_RELA_MENU_CNT", binding: "authRelaMenuCnt", width: "*" }]},
    ],
    body: [
        { cells: [ { binding: "ptlTpCd"}] },
        { cells: [ { binding: "roleId"}] },
        { cells: [ { binding: "roleNm"  , align: "left"}] },
        { cells: [ { binding: "roleDesc", align: "left"}] },
        { cells: [ { binding: "authId"}] },
        { cells: [ { binding: "authRelaMenuCnt"}] }
    ],
}

export const SG_ROLE_AUTH_CNCT_LIST:TGridSchema = {
    id: "grid_roleAuthCnctList",
    options: { checkbox: true, index: true, pagination: "in" },
    head: [
        { cells: [{ header: "L_PTL_TP_CD"         , binding: "ptlTpCd"        , width: "*" }], show: false },
        { cells: [{ header: "L_ROLE_ID"           , binding: "roleId"         , width: "*" }], show: false },
        { cells: [{ header: "L_AUTH_ID"           , binding: "authId"         , width: "*" }]},
        { cells: [{ header: "L_AUTH"              , binding: "authNm"         , width: "*" }]},
        { cells: [{ header: "L_DESC"              , binding: "authDesc"       , width: "*" }]},
        { cells: [{ header: "L_AUTH_RELA_MENU_CNT", binding: "authRelaMenuCnt", width: "*" }]},
    ],
    body: [
        { cells: [ { binding: "ptlTpCd"}] },
        { cells: [ { binding: "roleId"}] },
        { cells: [ { binding: "authId"}] },
        { cells: [ { binding: "authNm"  , align: "left"}] },
        { cells: [ { binding: "authDesc", align: "left"}] },
        { cells: [ { binding: "authRelaMenuCnt"}] }
    ],
}

export const SG_AUTH_LIST:TGridSchema = {
    id: "grid_authList",
    options: { checkbox: true, pagination: "out" },
    head: [
        { cells: [{ header: "L_PTL_TP_CD"         , binding: "ptlTpCd"        , width: "*" }], show: false },
        { cells: [{ header: "L_AUTH_ID"           , binding: "authId"         , width: "*" }]},
        { cells: [{ header: "L_AUTH_NM"           , binding: "authNm"         , width: "*" }]},
        { cells: [{ header: "L_AUTH_RELA_MENU_CNT", binding: "authRelaMenuCnt", width: "*" }]},
    ],
    body: [
        { cells: [ { binding: "ptlTpCd"}] },
        { cells: [ { binding: "authId"}] },
        { cells: [ { binding: "authNm", align: "left"}] },
        { cells: [ { binding: "authRelaMenuCnt"}] }
    ],
}
export const SG_MENU_LIST:TGridSchema = {
    id: "grid_menuList",
    options: {index: true, pagination: "in"},
    head: [

        { cells: [{ header: "L_MENU_ID"       , binding: "menuId", width: "*" }]},
        { cells: [{ header: "L_MENU_NM"       , binding: "menuNm", width: "*" }]},
    ],
    body: [
        { cells: [ { binding: "menuId"}] },
        { cells: [ { binding: "menuNm", align: "left"}] },
    ],
}
